import React from 'react'
import { Button } from 'hljd'

export default store => [
  {
    title: '商品名称',
    dataIndex: 'title',
    key: 'title',
    width: 280,
    render: (text, { cover_path, id }) => {
      return (
        <div style={{ display: 'flex' }}>
          <img
            src={cover_path}
            style={{ width: '100px', height: '62px', display: 'block' }}
          />
          <div style={{ flex: '1', marginLeft: '20px' }}>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={
                '/p/wedding/Web/Detail/detail/type/package/id/' +
                id +
                '/admin/true'
              }
            >
              {text}
            </a>
          </div>
        </div>
      )
    }
  },
  {
    title: '价格',
    key: 'show_price',
    dataIndex: 'show_price',
    width: 126,
    render: show_price => {
      return <span>￥{show_price}</span>
    }
  },
  {
    title: '供应时间',
    key: 'created_at',
    dataIndex: 'created_at',
    width: 126
  },
  {
    title: '操作',
    key: 'operate',
    dataIndex: 'operate',
    width: 126,
    render: (text, { is_selected = 0, id }) => {
      return (
        <div className="table-operate">
          {is_selected == 0 ? (
            <Button type="primary" onClick={() => store.addSupplyMeal(id)}>
              添加商品
            </Button>
          ) : (
            <div>
              <p>已上架</p>
              <a
                href="javascript:;"
                style={{ paddingLeft: '10px' }}
                onClick={() => store.removeSupplyMeal(id)}
              >
                撤销
              </a>
            </div>
          )}
        </div>
      )
    }
  }
]
